<template>
  <div class="menuSection">
    <h2 class="optionTitle">{{ $t('selectColor') }}</h2>

    <div id="colorSelect">
      <div v-for="style in classicStyles" :key="style.id" class="colContainer">
        <input
          :id="style.id"
          :checked="posterColor == style.id"
          name="colorSelector"
          type="radio"
          :value="style.id"
          v-model="selectedStyleId"
          @change="$emit('change', $event.target.value)"
        />
        <label class="colPicker" :for="style.id">
          <svg width="100%" height="100%" viewBox="0 0 100 100">
            <polygon points="0,0 0,100 100,100" :fill="style.background" />
            <polygon
              points="0,0 100,0 100,100"
              :fill="style.gradient.color_1"
            />
          </svg>
        </label>
      </div>
    </div>

    <div id="color-label">
      <span>{{ $t('selection') }}</span
      ><span id="color-selected-name">{{
        $t(`color.${selectedStyleId}`)
      }}</span>
    </div>
  </div>
</template>
<script>
import classicStyles from '../../data/classicStyles.json'

export default {
  name: 'ColorSelectorNew',
  model: {
    prop: 'posterColor',
    event: 'change',
  },
  props: {
    posterColor: String,
  },
  data() {
    return {
      selectedStyleId: this.posterColor,
    }
  },
  computed: {
    classicStyles() {
      return classicStyles.filter((style) => style.isActive)
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#color-selected-name {
  font-size: 0.78em;
  color: #898989;
  padding-left: 0.5em;
}

#colorSelect {
  margin-top: 0.3em;
  margin-bottom: 10px;
  padding: 7px;
  -webkit-font-smoothing: antialiased;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: stretch;
  background-color: whitesmoke;
}

#color-label {
  padding: 5px 0px;
}

label {
  box-sizing: border-box;
}

input[type='radio'] {
  display: none;
}

input[type='radio']:checked + .colPicker {
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.15), 0 0 0px 5px var(--colorPrimary);
}

label {
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.15);
  &:hover {
    box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.15),
      0 0 0px 5px var(--colorPrimary);
    z-index: 10;
  }
}

.colPickerInner {
  width: 25%;
  height: 25%;
}

.colContainer {
  width: 30%;
  box-sizing: border-box;
  padding: 0.6em;
}

.colPicker {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  transition: 0.3s;
  cursor: pointer;
  box-sizing: border-box;
  padding: 0;
  margin: 0;
  border: 0;
}
</style>
